/**
 * トップページからリンクする公用予定表（共有URL）。
 * DB データは migrations/db-restore-patches.sql の RS_DEMO_SEED 節で投入（開発正本・手動復旧バンドル Section 3–4）。
 * 共有URLを再発行した場合は RS_FEATURED_PUBLIC_BOARD_SHARE_TOKEN と RS_DEMO_SEED の demo_token を更新すること。
 */
export const RS_FEATURED_PUBLIC_BOARD_SHARE_TOKEN =
  '6OCaux5-d686dyqOWlPI_uhIQOooOISaQFEbFdhUdIA';

/** 本番公開 URL（トップのデモリンク・外部共有の正） */
export const RS_FEATURED_PUBLIC_BOARD_ORIGIN = 'https://kensuke-system.com';

export const RS_FEATURED_PUBLIC_BOARD_PATH = `/reservations/share/${RS_FEATURED_PUBLIC_BOARD_SHARE_TOKEN}`;

export const RS_FEATURED_PUBLIC_BOARD_URL = `${RS_FEATURED_PUBLIC_BOARD_ORIGIN}${RS_FEATURED_PUBLIC_BOARD_PATH}`;
